module.exports = __webpack_public_path__ + "media/images/shared/laurel_signature-07d973ab45da40f842d89665bddd5588d67d9272cb2c5e5e6ff08dd7cbfd6ea4.png";